import {
  COMPLETED,
  COMPLETED_EXPIRATION,
  CONFIRMED_LABEL,
  EXPIRED,
  IN_PROGRESS,
  NOVISIT_LABEL,
  VISITED_LABEL,
  WAIT,
  WAITING_LABEL,
} from '@app/constants';

export const getStatusColor = (status: string | null) => {
  switch (status) {
    case WAITING_LABEL:
    case WAIT:
      return '#bfbfbf';
    case CONFIRMED_LABEL:
    case IN_PROGRESS:
      return '#F0AD4E';
    case VISITED_LABEL:
    case COMPLETED:
      return '#2DA540';
    case NOVISIT_LABEL:
    case EXPIRED:
      return '#E14F4F';
    case COMPLETED_EXPIRATION:
      return '#1677ff';
    default:
      return '#000000';
  }
};
